export const APP_NAME = process.env.REACT_APP_APP_NAME || 'Hafiz Store';
export const API_URL = process.env.REACT_APP_API_URL;

export const ROLES = {
  USER: 'user',
  SELLER: 'seller',
  ADMIN: 'admin',
};

export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  REGISTER: '/register',
  DASHBOARD: '/dashboard',
  PROFILE: '/profile',
  USERS: '/users',
  FORGOT_PASSWORD: '/forgot-password',
  VERIFY_OTP: '/verify-otp',
  RESET_PASSWORD: '/reset-password',
  PRODUCTS: '/products',
  PRODUCT_DETAIL: '/products/:slug',
  CART: '/cart',
  CHECKOUT: '/checkout',
  ORDERS: '/orders',
  ORDER_SUCCESS: '/order-success/:id',
  BECOME_SELLER: '/become-seller',
  SELLER: '/seller',
  SELLER_PRODUCTS: '/seller/products',
  SELLER_ORDERS: '/seller/orders',
  ADMIN: '/admin',
  ADMIN_USERS: '/admin/users',
  ADMIN_ORDERS: '/admin/orders',
  ADMIN_PRODUCTS: '/admin/products',
  ADMIN_CATEGORIES: '/admin/categories',
  ADMIN_SELLER_APPLICATIONS: '/admin/seller-applications',
  PAYMENT: '/payment/:orderId',
  PAYMENT_FAILED: '/payment-failed',
};

export const QUERY_KEYS = {
  ME: ['me'],
  USERS: ['users'],
  USER: (id) => ['user', id],
};

export const TOAST_DURATION = 3000;
